/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-equipment.reducer';

export const DiaglabEquipmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabEquipmentEntity = useAppSelector(state => state.diaglabEquipment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabEquipmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabEquipment.detail.title">DiaglabEquipment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.name">Name</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.name}</dd>
          <dt>
            <span id="aeTitle">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.aeTitle">Ae Title</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.aeTitle}</dd>
          <dt>
            <span id="supended">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.supended">Supended</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.supended ? 'true' : 'false'}</dd>
          <dt>
            <span id="mfdDate">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.mfdDate">Mfd Date</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.mfdDate}</dd>
          <dt>
            <span id="dateSupended">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.dateSupended">Date Supended</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.dateSupended}</dd>
          <dt>
            <span id="reasonSupended">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.reasonSupended">Reason Supended</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.reasonSupended}</dd>
          <dt>
            <span id="maintainanceCycle">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.maintainanceCycle">Maintainance Cycle</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.maintainanceCycle}</dd>
          <dt>
            <span id="lastMaintenanceDate">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.lastMaintenanceDate">Last Maintenance Date</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.lastMaintenanceDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.timestampEntry}</dd>
          <dt>
            <span id="mwl">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.mwl">Mwl</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.mwl ? 'true' : 'false'}</dd>
          <dt>
            <span id="underMaintainance">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.underMaintainance">Under Maintainance</Translate>
            </span>
          </dt>
          <dd>{diaglabEquipmentEntity.underMaintainance ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabEquipment.equipment">Equipment</Translate>
          </dt>
          <dd>{diaglabEquipmentEntity.equipment ? diaglabEquipmentEntity.equipment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabEquipment.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabEquipmentEntity.diagLab ? diaglabEquipmentEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-equipment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-equipment/${diaglabEquipmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabEquipmentDetail;
